<template>
  <header id="site-header">
    <div class="container">
      <a class="logo" href="/">
        <img src="/images/common/logo.webp" alt="REIWA STEEL Co.,Ltd.">
      </a>
    
      <div class="trg" @click="toggle = !toggle">
        <div class="trg__border" :class="{'active': toggle}">
          <i></i>
          <i></i>
          <i></i>
        </div>
      </div>
      <div v-show="toggle" class="toggle" :class="{'active': toggle}">
        <nav class="gnavi" role="navigation" itemscope="itemscope" itemtype="http://scheme.org/SiteNavigationElement">
          <ul>
            <li v-for="item in list" :key="item.url" itemprop="name">
              <a itemprop="url" :href="item.url" :class="{ active: isActive(item.url) }">{{ item.name }}</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
#site-header{
  width: 100%;
  background: #FFF;
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 0 .1rem .7rem rgba(#000,.08);
  z-index: 2000;
  .container{
    padding: 1.7rem module.side();
    max-width: 1440px;
    margin: 0 auto;
    @media screen and (max-width: module.$tab){
      padding: 0 1.6rem;
      height: 5.6rem;
      @include module.flex();
      align-items: center;
    }
  }
  .logo{
    display: inline-block;
    vertical-align: bottom;
    img{
      height: 2.4rem;
      display: block;
    }
  }
  .trg{
    display: none;
    @media screen and (max-width: module.$tab){
      display: block;
      width: 3rem;
      height: 3rem;
      position: relative;
      cursor: pointer;
      &__border{
        position: absolute;
        top: 50%;
        left: 50%;
        width: 60%;
        height: 40%;
        transform: translate(-50%, -50%);
        i{
          width: 100%;
          height: 2px;
          background: module.$normal;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          transition: all 300ms module.$ease;
          transition-property: width, transform, top;
          &:nth-child(1){
            top: 0;
          }
          &:nth-child(2){
            top: 50%;
            transform: translate(-50%, -50%);
          }
          &:nth-child(3){
            top: 100%;
            transform: translate(-50%, -100%);
          }
        }
        &.active{
          i{
            &:nth-child(1){
              top: 50%;
              transform: translate(-50%, -50%) rotate(45deg);
            }
            &:nth-child(2){
              width: 0;
            }
            &:nth-child(3){
              top: 50%;
              transform: translate(-50%, -50%) rotate(-45deg);
            }
          }
        }
      }
    }
  }
  .toggle{
    @media screen and (min-width: calc(#{module.$tab} + 1px)){
      display: block !important;
    }
    @media screen and (max-width: module.$tab){
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }
    .gnavi{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      @media screen and (max-width: module.$tab){
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 5.8rem 0 0;
        transform: translate(0);
        background: #FFF;
      }
      ul{
        @include module.flex();
        align-items: center;
        justify-content: center;
        gap: 2.4rem;
        @media screen and (max-width: module.$tab){
          display: block;
        }
        li{
          @media screen and (max-width: module.$tab){
            border-top: module.$border 1px solid;
            &:last-child{
              border-bottom: module.$border 1px solid;
            }
          }
          a{
            color: module.$normal;
            font-weight: 700;
            display: block;
            position: relative;
            transition: color 300ms module.$ease;
            @media screen and (max-width: module.$tab){
              padding: 1rem;
              text-align: center;
              font-size: 1.12rem;
            }
            &:before{
              content: '';
              width: 0;
              height: 3px;
              background: module.$main;
              position: absolute;
              left: 50%;
              bottom: -.5rem;
              transform: translateX(-50%);
              transition: width 300ms module.$ease;
              @media screen and (max-width: module.$tab){
                display: none;
              }
            }
            &.active,
            &:hover{
              color: module.$main;
              &:before{
                width: 100%;
              }
            }
            &.active{
              transition: all 0;
              &:before{
                transition: all 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    list: {
      type: Array,
      require: true,
    }
  },
  data: function(){
    return {
      toggle: false
    }
  },
  methods: {
    isActive(path) {
      if(path == window.location.pathname){
        return true
      }
    }
  },
}
</script>
